import React from "react";
import Page from "../../../common/layout/Page";
import Pagination from "../../../common/Pagination/Pagination";
import useShopAtoms from "../atoms/useShopAtoms";
import ShopsFilters from "./ShopsFilters";
import ShopsListTable from "./ShopsListTable";

const ShopsList = (props) => {
  const { errors, isLoading, searchFilters, actions, searchList } = useShopAtoms();

  return (
    <Page
      title="Shops"
      errors={errors}
      isLoading={isLoading}
      action={{
        to: "shops/create",
        text: "Créer une boutique",
      }}
      {...props}
    >
      <div className="">
        <ShopsFilters />
        <div className="mt-3">
          <ShopsListTable />
        </div>
        {searchList.count ? (
          <Pagination
            nbPages={Math.ceil(searchList.count / 25)}
            page={searchFilters.page}
            changePage={(p) => {
              // shops_actions.updatePage({
              //   ...shopsFilters,
              //   page: p,
              // })
            }}
          />
        ) : null}
      </div>
    </Page>
  );
};

export default ShopsList;
